import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { RouterAccessService } from './router-access.service';
import { AB_LOGIN_FORM_URL, AB_SENTOO } from '../constants';
import { isPlatformServer } from '@angular/common';
import { PortfolioService } from './portfolio.service';
import { DefaultPortfolioService } from './default-portfolio.service';
import { MessagesCountService } from '../../personal-archive/services/messages-count.service';
import { SessionService } from '../../session/services/session.service';
import { InitialViewService } from './initial-view.service';
import { FullPortfolioViewService } from './full-portfolio-view.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private access: boolean;
  private wasLoggedIn = false;
  private openSessionPopup: () => void;
  private isFirstTime = false;

  constructor(
    private routerAccessService: RouterAccessService,
    private router: Router,
    @Inject(PLATFORM_ID) private platform,
    private portfolioService: PortfolioService,
    private defaultPortfolioService: DefaultPortfolioService,
    private messagesCountService: MessagesCountService,
    private sessionService: SessionService,
    private initialViewSerivce: InitialViewService,
    private fullPortfolioViewService: FullPortfolioViewService
  ) {}

  public get hasAccess() {
    return this.access;
  }

  initOpenPopUp(fn: () => void) {
    this.openSessionPopup = fn;
  }

  userHasAccess(url: string) {
    if (url.indexOf('?') !== -1) {
      url = url.split('?')[0];
    }

    return new Observable<boolean>((observer) => {
      this.checkAccess(url, observer);
    });
  }

  logoutUser() {
    this.clearServices(true);
    this.router.navigate([AB_LOGIN_FORM_URL]);
  }

  private clearServices(logout: boolean = false) {
    this.wasLoggedIn = false;
    this.defaultPortfolioService.clearDefaultPortfolio();
    this.portfolioService.clearPortfolios(logout);
    this.messagesCountService.cleanUnreadMessagesCount();
    this.fullPortfolioViewService.clearBankAccounts();
    this.initialViewSerivce.clearAccountsOverview();
  }

  private checkAccess(url, observer) {
    this.routerAccessService.checkRouteAccess(url).subscribe(
      (result) => {
        this.access = result.access;

        if (isPlatformServer(this.platform)) {
          observer.next(true);
        }

        if (result.redirectUrl) {
          if (this.wasLoggedIn && result.redirectUrl === AB_LOGIN_FORM_URL) {
            this.openSessionPopup();
            this.wasLoggedIn = false;
            observer.next(false);
            return;
          }

          this.clearServices();
          this.isFirstTime = result.redirectUrl === AB_LOGIN_FORM_URL;
          this.router.navigate([result.redirectUrl]);
          observer.next(false);
        } else {
          this.wasLoggedIn = url !== AB_LOGIN_FORM_URL;

          if (
            !this.isFirstTime &&
            url !== AB_LOGIN_FORM_URL &&
            url !== AB_SENTOO
          ) {
            this.sessionService.refreshSession().subscribe(
              () => {
                observer.next(true);
              },
              () => {
                observer.next(true);
              }
            );

            this.isFirstTime = true;
          } else {
            this.isFirstTime = true;
            observer.next(true);
          }
        }
      },
      (error) => {
        if (error.status === 401) {
          this.logoutUser();
        }

        observer.next(false);
      }
    );
  }
}
